const path = require('path');

module.exports = {
  contentFul: {
    spaceId: '74annprh05jq',
    access_token: '35fKbOOuliVMj_wgyyRrJzOVKsgGpzkeKk7nHsa-z3E',
  },
  siteTitle: 'Lauv | Official Site',
  siteTitleShort: 'Lauv | Official Site',
  siteDescription:
    'Music, tour dates, official videos and more from Lauv. Stream and watch his new song “Fake” with Conan Gray, out now!',
  siteUrl: 'http://lauvsongs.com',
  themeColor: '#000',
  backgroundColor: '#fff',
  pathPrefix: null,
  logo: path.resolve(__dirname, 'src/images/icon.png'),
  social: {
    twitter: 'lauvsongs',
    fbAppId: '966242223397117',
  },
};
